import { ButtonAsLink } from '@cluey/cluey-components';
import { useHistory } from 'react-router-dom';

import BackArrow from '../../../assets/images/hubContact/icon-filled-arrow-left.svg';

const BackButton = () => {
  const history = useHistory();
  const goBack = () => {
    history.goBack();
  };
  return (
    <ButtonAsLink className="mx-4 mb-5 p-0 lg:mx-0" onClick={goBack}>
      <img height={24} width={24} src={BackArrow} alt="back" />
    </ButtonAsLink>
  );
};

export { BackButton };
